export enum MfaMethods {
	push = 'PUSH',
	call = 'CALL',
	text = 'TEXT',
}